import {ErrorType, ExpectedErrorClasses} from '../graphQL/type';

import {Platform} from 'react-native';
import {REQUEST_TIMEOUT} from './constants';

/**
 *
 * @returns string
 */
export function getOs() {
  return Platform.OS.toString();
}

const expression = new RegExp(/^\d*(\.\d{0,2})?$/);

export const checkPriceDecimals = (value: string) => {
  try {
    return expression.test(value);
  } catch (error: any) {
    return false;
  }
};

export function isExpectedErrorClass(errorClass: string) {
  return Object.values(ExpectedErrorClasses).includes(
    errorClass as ExpectedErrorClasses,
  );
}

export function isNetworkError(error: ErrorType) {
  const {networkError, statusCode, name} = error;
  const isError =
    (networkError && networkError.statusCode === undefined) ||
    (networkError?.statusCode !== undefined &&
      networkError.statusCode >= 500) ||
    (statusCode !== undefined && statusCode >= 500) ||
    name?.includes?.('Network request failed') ||
    error?.message?.includes?.('Network request failed') ||
    error?.message?.includes?.('Network request timed out') ||
    error.message === REQUEST_TIMEOUT;
  return isError;
}

export function isGraphQLExpectedError(error: ErrorType) {
  const errorClass = error?.graphQLErrors?.[0]?.extensions?.code;
  const isGraphQLError =
    error?.graphQLErrors?.length &&
    errorClass &&
    isExpectedErrorClass(errorClass);
  return isGraphQLError;
}
